export const iconFontAwesomePoliticalHandshake = (
	<i className="fa-solid fa-handshake"></i>
);
